export function isInOtterApp() {
  const ua = window.navigator.userAgent;
  return ua.includes('OtterApp');
}
